export default "__VITE_ASSET__CFJbZ15I__"